import { useGetUser } from "../features/auth/useGetUser";
import { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import SpinnerFullPage from "./SpinnerFullPage";

type ProtectedRouteProps = {
  children: ReactNode;
};

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isPending, isError, error } = useGetUser();
  const location = useLocation();

  if (isPending) return <SpinnerFullPage />;

  if (isError && error?.status === 401) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isError && (error?.status === 0 || error?.status === 503)) {
    return null;
  }

  return children ?? <Outlet />;
}

export default ProtectedRoute;
